<template>
  <input
    ref="inputRef"
    type="text"
    :value="formattedValue"
    :placeholder="placeHolder"
  />
</template>

<script>
import { useCurrencyInput } from 'vue-currency-input'

export default {
  name: 'CurrencyInput',
  props: {
    modelValue: Number,
    options: Object,
    placeHolder: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const { formattedValue, inputRef } = useCurrencyInput(props.options)

    return { inputRef, formattedValue }
  }
}
</script>
